export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.arrivals', {
            url: '/arrivals',
            component: 'arrivalDashboard',
            roles: ['manager']
        });
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/guests/guests.routes.js